import React from 'react';
import './Login.css';
import FacebookLogin from 'react-facebook-login';

let Login = props => {
    return (
        <div className="login-action">
            <p>Login with Facebook<br/>to enter the competition</p>
            <FacebookLogin
                appId="158573034958328"
                fields="name,email,picture"
                onClick={props.getLogin.loading}
                callback={props.getLogin.set} />
        </div>
    );
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Header/Login/Login.jsx